var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMapPinLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 54.8612L44.493 41.868C51.6689 34.6923 51.6689 23.0578 44.493 15.8819C37.3173 8.70602 25.6828 8.70602 18.5069 15.8819C11.331 23.0578 11.331 34.6923 18.5069 41.868L31.5 54.8612ZM31.5 62.2857L14.7946 45.5805C5.56847 36.3542 5.56847 21.3957 14.7946 12.1696C24.0207 2.94347 38.9792 2.94347 48.2055 12.1696C57.4316 21.3957 57.4316 36.3542 48.2055 45.5805L31.5 62.2857ZM31.5 34.125C34.3996 34.125 36.75 31.7746 36.75 28.875C36.75 25.9755 34.3996 23.625 31.5 23.625C28.6004 23.625 26.25 25.9755 26.25 28.875C26.25 31.7746 28.6004 34.125 31.5 34.125ZM31.5 39.375C25.701 39.375 21 34.6739 21 28.875C21 23.076 25.701 18.375 31.5 18.375C37.2989 18.375 42 23.076 42 28.875C42 34.6739 37.2989 39.375 31.5 39.375Z",
    fill: "#BFD6D2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMapPinLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map-pin-line.bb2f5f38.svg";
export { ForwardRef as ReactComponent };